export default "__VITE_ASSET__bQVN0DBl__"